<template>
  <div>
    <div class="a-container-form contractor__block">
      <div class="a-label">{{$t('form.contractor.type-of-organization')}}:</div>
      <dropdown-new class="contractor__status select-w-380" v-model="type">
        <option :value="enums.OrganizationType.NONE" :label="'org-type.none'" disabled></option>
        <option :value="enums.OrganizationType.PERSON" :label="'org-type.person'"></option>
        <option :value="enums.OrganizationType.ORGANIZATION" :label="'org-type.organization'"></option>
        <option :value="enums.OrganizationType.IP" :label="'org-type.ip'"></option>
      </dropdown-new>
    </div>
    <div class="a-container-form contractor__block">
      <div class="a-label ">{{$t('form.contractor.person-status')}}:</div>
      <dropdown-new class="contractor__status select-w-380" v-model="resident">
        <option value="resident" :label="'person-status.resident'"></option>
        <option value="non-resident" :label="'person-status.non-resident'"></option>
      </dropdown-new>
    </div>
    <div class="a-container-form contractor__block">
      <div class="a-label ">{{$t('form.contractor.full-title')}}:</div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__name-contractor a-input--w-380" :placeholder="$t('form.contractor.full-title')" v-model.trim="fullName">
        <span class="a-helper-text a-validation-error" v-if="$v.fullName.$dirty && !$v.fullName.required">{{$t('labels.mandatory-field')}}</span>
      </div>
    </div>
    <div class="a-container-form contractor__block" v-if="permissions.CAN_VIEW_ADMIN">
      <div class="a-label ">{{$t('form.contractor.short-title')}}:</div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__name-contractorm a-input--w-380" :placeholder="$t('form.contractor.short-title')" v-model.trim="shortName">
        <span class="a-helper-text a-validation-error" v-if="$v.shortName.$dirty && !$v.shortName.required">{{$t('labels.mandatory-field')}}</span>
      </div>
    </div>
    <div class="a-container-form contractor__block">
      <div class="a-label ">{{$t('labels.inn-long')}}:</div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__inn a-input--w-380" :placeholder="$t('labels.inn-long')" maxlength="25" v-model.trim="inn">
        <span class="a-helper-text a-validation-error" v-if="$v.inn.$dirty && !$v.inn.required">{{$t('labels.mandatory-field')}}</span>
        <span class="a-helper-text a-validation-error" v-else-if="$v.inn.$dirty && !$v.inn.valid">{{$t('validation-error.invalid-format')}}</span>
      </div>
    </div>
    <div class="a-container-form contractor__block" v-if="showBoss">
      <div class="a-label">{{$t('form.contractor.chief')}}:</div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__head" :placeholder="$t('labels.lastname')" v-model.trim="boss.lastName">
        <span class="a-helper-text a-validation-error" v-if="$v.boss.lastName.$dirty && !$v.boss.lastName.required">{{$t('labels.mandatory-field')}}</span>
      </div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__head"  :placeholder="$t('labels.firstname')" v-model.trim="boss.firstName">
        <span class="a-helper-text a-validation-error" v-if="$v.boss.firstName.$dirty && !$v.boss.firstName.required">{{$t('labels.mandatory-field')}}</span>
      </div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__head" :placeholder="$t('labels.middlename')" v-model.trim="boss.middleName">
      </div>
    </div>
    <div class="a-container-form contractor__block" v-if="showAccountant">
      <div class="a-label">{{$t('form.contractor.chief-accountant')}}:</div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__head" :placeholder="$t('labels.lastname')" v-model.trim="accountant.lastName">
<!--        <span class="a-helper-text a-validation-error" v-if="$v.accountant.lastName.$dirty && !$v.accountant.lastName.required">{{$t('labels.mandatory-field')}}</span>-->
      </div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__head" :placeholder="$t('labels.firstname')" v-model.trim="accountant.firstName">
<!--        <span class="a-helper-text a-validation-error" v-if="$v.accountant.firstName.$dirty && !$v.accountant.firstName.required">{{$t('labels.mandatory-field')}}</span>-->
      </div>
      <div class="a-form-field">
        <input type="text" class="a-input contractor__head" :placeholder="$t('labels.middlename')" v-model.trim="accountant.middleName">
      </div>
    </div>

    <div class="a-container-form contractor__block" v-if="showAccountant">
      <div class="a-checkbox">
        <label class="a-checkbox__label">
          <input class="a-checkbox__input"
                 type="checkbox"
                 v-model="accountant.accountantOut">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">
            Бухгалтерия на аутсорсинге
          </span>
        </label>
      </div>
    </div>

    <div class="personal-data__btn-block contractor__btn-block">
      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" v-t="'buttons.save'" @click="onSaveClick"></button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" type="button" @click="$emit('close')" v-t="'buttons.cancel'"></button>
    </div>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import { required, minLength, maxLength, and } from '@/validators'
  import OrganizationType from '@/api/types/organization-type'

  export default {
    name: "ContractorEditMode",

    data: () => ({
      loading: false,
      id: undefined,
      type: 'person',
      resident: 'resident',
      fullName: undefined,
      shortName: undefined,
      inn: undefined,
      boss: {
        firstName: undefined,
        lastName: undefined,
        middleName: undefined
      },
      accountant: {
        firstName: undefined,
        lastName: undefined,
        middleName: undefined,
        accountantOut: undefined
      }
    }),

    validations: {
      fullName: {
        required
      },
      shortName: {
        required: (v, vm) => { return vm.permissions.CAN_VIEW_ADMIN ? required(v) : true }
      },
      inn: {
        required,
        valid: and(minLength(5), maxLength(25))
      },
      boss: {
        firstName: {
          required: function(v) { return this.showBoss ? required(v) : true }
        },
        lastName: {
          required: function(v) { return this.showBoss ? required(v) : true }
        },
      },
      // accountant: {
      //   firstName: {
      //     required: function(v) { return this.showAccountant ? required(v) : true }
      //   },
      //   lastName: {
      //     required: function(v) { return this.showAccountant ? required(v) : true }
      //   },
      // }
    },

    computed: {
      permissions() { return this.$store.getters.currentUser.permissions },

      showBoss() {
        return this.type != OrganizationType.PERSON;
      },
      showAccountant () {
        return this.type != OrganizationType.PERSON
      }
    },

    created() {
      const org = this.$store.getters.currentOrganization;

      if (org) {
        Object.assign(this.$data, org);
      }

      if (!this.$data.id) {
        this.$data.id = this.$store.getters.currentUser.organizationId;
      }
    },

    methods: {
      async onSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            const org = { ...this.$data, type: this.$data.type + '' };

            if (!this.showBoss) {
              delete org.boss;
            }

            if (!this.showAccountant) {
              delete org.accountant;
            }

            await this.$store.dispatch('saveOrganization', { ...org });
            this.$emit('close');
          }
          catch(e) {
            console.error('unable to save changes in contractor', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
